export var treeMenuType;
(function (treeMenuType) {
    treeMenuType[treeMenuType["expandable"] = 1] = "expandable";
    treeMenuType[treeMenuType["expanded"] = 2] = "expanded";
    treeMenuType[treeMenuType["collapse"] = 3] = "collapse";
})(treeMenuType || (treeMenuType = {}));
